<template>
  <div class="mgt-20px">
    <div class="card">
      <header class="header-card">
        <p>{{ $t('editionDemandeImpression.infoGenerale.dispositif')}}</p>
      </header>
      <div class="card-content">
        <div class="columns">
          <div class="column is-6">
            <div class="columns is-multiline">
              <b-field
                class="column is-12"
                :label="$t('editionDemandeImpression.infoGenerale.dispositif')">
                <b-autocomplete
                  v-model="dispositif"
                  :placeholder="$t('editionDemandeImpression.infoGenerale.dispositif')"
                  :data="dispositifs"
                  field="libelle"
                  :loading="isFetchingDispositif"
                  :open-on-focus="true"
                  icon="magnify"
                  @select="option => updateSocieteIdByDispositif(option)"
                  @input="getDispositifsDebounce">
                  <template #empty>
                    {{$t(`general.autocomplete.${!isFetchingDispositif
                      ? 'noRslt' : 'search'}`)}}
                  </template>
                  <template slot-scope="props">
                    <div class="dropdown-item  is-paddingless" v-if="props.option.id">
                      <div class="columns is-marginless is-multiline">
                        <div class="column pdv-0">
                          <span class="has-text-weight-bold">
                            {{props.option.code}}
                          </span>
                          <span v-if="props.option.dispositifType">
                            &nbsp;➔&nbsp;{{props.option.dispositifType.libelle}}
                          </span>
                          <span v-if="props.option.etat">
                            &nbsp;-&nbsp;{{$t(getEtatMontage(props.option.etat))}}
                          </span>
                          <span v-if="props.option.materiels.length">
                            &nbsp;-&nbsp;{{getMaterielTypeLibelle(props.option.materiels)}}
                          </span>
                        </div>
                        <div class="column is-12 is-size-8 pdv-0"
                          v-if="props.option.adresse">
                          {{importedFunction.adressFullStringGetter(props.option.adresse)}}
                        </div>
                      </div>
                    </div>
                  </template>
                </b-autocomplete>
              </b-field>
              <b-field :label="$t('detailDemandeImpression.dispositif.typeDispositif')"
                class="column is-12 is-marginless">
                <b-input disabled
                  v-model="dispositifType">
                </b-input>
              </b-field>
              <b-field :label="$t('detailDemandeImpression.dispositif.typeMateriel')"
                class="column is-12 is-marginless">
                <b-input disabled
                  v-model="materielTypeLibelle">
                </b-input>
              </b-field>
            </div>
          </div>
          <div class="column is-6">
            <adresse v-if="dispositifAdresse"
              :adresse="dispositifAdresse"
              :afficherIntitule="false"
              :showGmapAuto="false"
              :isDisabled="true"
              :showLibellePays="true"
              :tableName="EMPLACEMENT"/>
          </div>
        </div>
      </div>
      </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import { getAll as getAllDispositif } from '@/api/gabed/dispositif';
import { createNamespacedHelpers } from 'vuex';
import messageErreur from '@/services/general/messageErreur';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import adresse from '@/components/general/adresse';
import { EMPLACEMENT } from '@/configuration/ville/villeConf';
import { ETAT_DISPOSITIF_PUBLICITAIRE } from '@/configuration/gabed/dispositif/dispositifPublicitaire';
import { getTypeMaterielLibelle } from '@/services/gabed/dispositif/dispositifService';

const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'editionDispositif',
  props: {
    demandeImpression: {
      type: Object,
      required: true,
    },
    clientId: {
      type: String,
      required: false,
    },
  },
  components: {
    adresse,
  },
  data() {
    return {
      dispositifs: [],
      search: null,
      isFetchingDispositif: false,
      dispositif: null,
      dispositifType: '',
      dispositifAdresse: null,
      materielTypeLibelle: '',
      importedFunction: {
        adressFullStringGetter,
      },
      EMPLACEMENT,
    };
  },
  watch: {
    clientId() {
      this.dispositif = null;
      this.dispositifType = '';
      this.materielTypeLibelle = '';
      this.dispositifAdresse = null;
      this.getDispositifsDebounce('');
    },
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    dispositifTypes() {
      return this.parametre(PARAMETRES_KEYS.dispositifType);
    },
    materielTypes() {
      return this.parametre(PARAMETRES_KEYS.materielType);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    getEtatMontage(etat) {
      const etatFind = ETAT_DISPOSITIF_PUBLICITAIRE.find((e) => e.value === etat);
      return etatFind?.libelle || null;
    },
    getDispositifsDebounce: debounce(async function getContacts(search) {
      if (!this.demandeImpression.clientId) return;
      try {
        this.isFetchingDispositif = true;
        this.dispositifs = (await getAllDispositif({
          query: {
            auto: search,
            brouillon: null,
            societeId: this.societeActiveId,
            clientIds: [this.demandeImpression.clientId],
          },
        })).data.result.items
          .map(item => {
            item.libelle = [
              item.code,
              item.dispositifType?.libelle,
              adressFullStringGetter(item.adresse),
              item.etatMontage,
            ].filter(Boolean).join(', ');
            return item;
          });
        this.isFetchingDispositif = false;
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        this.isFetchingDispositif = false;
      }
    }, 300),
    getFirstMaterielTypeColor(materiels) {
      return materiels.find(mat => mat.typeId && mat.type?.couleur)?.type?.couleur;
    },
    updateSocieteIdByDispositif(option) {
      this.demandeImpression.dispositifId = option ? option.id : null;
      if (!this.demandeImpression.id) {
        this.demandeImpression.societeId = option && option.emplacement
          ? option.emplacement.societeId : this.societeActiveId;
      }
      this.dispositifType = option ? this.dipositifTypeLibelle(option.dispositifTypeId) : '';
      this.materielTypeLibelle = option ? this.getMaterielTypeLibelle(option.materiels) : '';
      this.dispositifAdresse = option?.adresse ?? null;
      this.demandeImpression.couleur = option && this.getFirstMaterielTypeColor(option.materiels)
        ? this.getFirstMaterielTypeColor(option.materiels) : this.demandeImpression.couleur;
    },
    dipositifTypeLibelle(dispositifTypeId) {
      return this.dispositifTypes.find(t => t.id === dispositifTypeId)?.libelle ?? '';
    },
    getMaterielTypeLibelle(materiels) {
      return getTypeMaterielLibelle(materiels, this.materielTypes);
    },
  },
  async mounted() {
    await this.loadParametres([
      PARAMETRES_KEYS.dispositifType,
      PARAMETRES_KEYS.materielType,
    ]);
    if (this.demandeImpression.dispositif) {
      this.dispositifType = this.dipositifTypeLibelle(
        this.demandeImpression.dispositif.dispositifTypeId);
      this.materielTypeLibelle = this.getMaterielTypeLibelle(
        this.demandeImpression.dispositif.materiels);
    }
    this.dispositifAdresse = this.demandeImpression.dispositif?.adresse ?? null;
    this.dispositif = this.demandeImpression.dispositif?.code ?? '';
  },
};
</script>
